<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 5" :key="i" :style="{ backgroundColor: bg }">
      <!--  <shSkeleton bg="#e4e4e4" width="195px" height="120px" animated /> -->
      <shSkeleton bg="#e4e4e4" width="165px" height="24px" animated />
      <shSkeleton bg="#e4e4e4" width="150px" height="24px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  /* width: 230px;
  height: 320px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center; */
  .item {
    width: 230px;
    margin-top: 10px;
    margin-left: 15px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 8px auto 0;
    }
  }
}
</style>
